<template>
    <section class="section section-lg">
        <!-- <div class="shape shape-skew-gray">
        </div> -->

        <div class="container">
            <div class="row">
                <div class="mb-5">
                    <h2>The Team</h2>
                    <p>
                        MemX 是一个跨学科的研究团队，涵盖认知科学、社会科学和计算机科学，致力于进行交互式视觉智能的探索性研究。MemX 团队由来自世界各地多所大学和研究实验室的研究人员组成，包括复旦大学、科罗拉多大学、密歇根大学、伦敦大学、牛津大学、思克莱德大学、巴斯大学、格拉斯哥大学和微软亚洲研究院。我们的目标是从人类的感知、情感、意识多个角度去推进以人为中心的计算路径，并不断去接近、甚至实现人工通用智能这一终极愿景。
                    </p>
                </div>
                <!-- <div>
                    <div class="d-block text-uppercase mb-4" style="font-size: 1.5rem;">Team members</div>
                    <div class="row">
                        <div class="col-md-6 col-lg-2 mb-3" :class="{ 'cursor-pointer': person.url }"
                            v-for="person in teams" :key="person.name" @click="open(person.url)">
                            <img v-lazy="'//memx-website.oss-cn-shanghai.aliyuncs.com/img/photos/' + person.photo"
                                class="img-center img-fluid shadow shadow-lg--hover"
                                style="width: 150px; height: 200px; object-fit:cover;">
                            <div class="pt-2 text-center">
                                <h5>{{ person.name }}</h5>
                                <i class="fa fa-link" v-if="person.url"></i>
                            </div>
                        </div>
                    </div>
                </div> -->


                <div>
                    <div class="d-block text-uppercase mb-4" style="font-size: 1.5rem;">Team members</div>
                    <div class="row">
                        <div class="col-md-12 mb-3" v-for="person in teams" :key="person.name">
                            <div class="d-flex align-items-start">
                                <img v-lazy="'/memx-website/img/photos/' + person.photo"
                                    class="img-start img-fluid shadow shadow-lg--hover"
                                    style="width: 150px; height: 200px; object-fit: cover; margin-right: 40px;">
                                <div>
                                    <div class="row" @click="open(person.url)">
                                        <h5 style="font-size: 1.5rem;">{{ person.name }}</h5>
                                        <i class="fa fa-link" v-if="person.url" style="margin-left: 10px;"></i>
                                    </div>

                                    <small class="text-muted" style="font-size: 1.2rem;">{{ person.title }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="d-block text-uppercase mb-4" style="font-size: 1.5rem;">Collaborators</div>
                    <div class="row">
                        <div class="col-md-12 mb-3" v-for="person in collaborators" :key="person.name">
                            <div class="d-flex align-items-start">
                                <img v-lazy="'/memx-website/img/photos/' + person.photo"
                                    class="img-start img-fluid shadow shadow-lg--hover"
                                    style="width: 150px; height: 200px; object-fit: cover; margin-right: 40px;">
                                <div>
                                    <div class="row" @click="open(person.url)">
                                        <h5 style="font-size: 1.5rem;">{{ person.name }}</h5>
                                        <i class="fa fa-link" v-if="person.url" style="margin-left: 10px;"></i>
                                    </div>
                                    <small class="text-muted" style="font-size: 1.2rem;">{{ person.title }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- <div>
                    <div class="d-block text-uppercase mb-4" style="font-size: 1.5rem;">Collaborators</div>
                    <div class="row">
                        <div class="col-md-6 col-lg-2 mb-3" :class="{ 'cursor-pointer': person.url }"
                            v-for="person in collaborators" :key="person.name" @click="open(person.url)">
                            <img v-lazy="'//memx-website.oss-cn-shanghai.aliyuncs.com/img/photos/' + person.photo"
                                class="img-center img-fluid shadow shadow-lg--hover"
                                style="width: 150px; height: 200px; object-fit:cover;">
                            <div class="pt-2 text-center">
                                <h5>{{ person.name }}</h5>
                                <i class="fa fa-link" v-if="person.url"></i>
                                <small class="h6 text-muted">{{ person.title }}</small>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div>
                    <div class="d-block text-uppercase mb-4" style="font-size: 1.5rem;">Students</div>
                    <div class="row">
                        <div class="col-md-6 col-lg-2 mb-3" :class="{ 'cursor-pointer': person.url }"
                            v-for="person in students" :key="person.name" @click="open(person.url)">
                            <img v-lazy="'/memx-website/img/photos/' + person.photo"
                                class="img-center img-fluid shadow shadow-lg--hover"
                                style="width: 150px; height: 200px; object-fit:cover;">
                            <div class="pt-2 text-center">
                                <h5>{{ person.name }}</h5>
                                <i class="fa fa-link" v-if="person.url"></i>
                                <!-- <small class="h6 text-muted">Professor</small> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="d-block text-uppercase mb-4" style="font-size: 1.5rem;">Alumnus</div>
                    <div class="row">
                        <div class="col-md-6 col-lg-2 mb-3" :class="{ 'cursor-pointer': person.url }"
                            v-for="person in alumnus" :key="person.name" @click="open(person.url)">
                            <img v-lazy="'/memx-website/img/photos/' + person.photo"
                                class="img-center img-fluid shadow shadow-lg--hover"
                                style="width: 150px; height: 200px; object-fit:cover;">
                            <div class="pt-2 text-center">
                                <h5>{{ person.name }}</h5>
                                <i class="fa fa-link" v-if="person.url"></i>
                                <!-- <small class="h6 text-muted">Professor</small> -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "about",
    data() {
        return {
            teams: [{
                'name': '尚笠',
                'photo': 'Li_Shang.jpg',
                'url': 'http://lishang.org/',
                'title': '复旦大学计算与智能创新学院教授，人机交互与协同计算方向负责人，博士生导师，上海市特聘专家。美国普林斯顿大学博士。曾任英特尔中国研究院副院长、首席架构师，美国科罗拉多大学博尔德分校（终身教职）。研究专注于以人为中心的机器学习算法与系统，在人机交互、机器学习、计算机系统、集成电路与EDA等领域发表论文180余篇，多次荣获最佳论文奖与提名，被引逾9000次。曾获美国NSF CAREER Award资助。在产业界有着丰富的经验，成功创立了一家智能可穿戴设备企业与一家数字孪生服务型企业，产品行销世界40多个国家和地区。'
            }, {
                'name': 'Robert P. Dick',
                'photo': 'Robert_P._Dick.jpg',
                'url': 'https://robertdick.org/',
                'title': '密歇根大学工程学院电气工程与计算机科学系教授，普林斯顿大学电气工程系博士。曾任西北大学电气工程与计算机科学系副教授、清华大学电子工程系的访问教授。研究领域涵盖嵌入式系统、高效、仿生机器学习、学习动态、隐私保护和对抗审查等方面。'
            }, {
                'name': '杨帆',
                'photo': 'Fan_Yang.jpg',
                'url': 'https://sme.fudan.edu.cn/65/41/c31277a353601/page.htm',
                'title': '复旦大学微电子学院教授，博导，复旦大学微电子学与固体电子学博士。研究领域涵盖人工神经网络的加速、集成电路成品率分析方法及优化、高层次综合方法、大规模电路快速分析建模以及并行计算方法。'
            }, {
                'name': '常玉虎',
                'photo': 'Yuhu_Chang.jpg',
                'url': 'https://cscw.fudan.edu.cn/yhchang/list.htm',
                'title': '博士后，复旦大学计算机软件与理论博士，密歇根大学电气工程与计算机科学系访问学者。研究领域为可穿戴人工通用智能、交互式人工通用智能。'
            }, {
                'name': '黄将历',
                'photo': 'Jiangli_Huang.jpg',
                'url': 'https://cscw.fudan.edu.cn/yhchang/list.htm',
                'title': '博士后，复旦大学微电子与固体电子学博士，研究领域为电子设计自动化（EDA）、通过机器学习进行模拟电路设计以及软件开发。'
            }],
            collaborators: [{
                'name': '吕琴',
                'photo': 'Qin_Lv.jpg',
                'url': 'https://home.cs.colorado.edu/~lv/',
                'title': '科罗拉多大学博尔德分校计算机科学系教授，普林斯顿大学计算机博士。研究聚焦于全栈数据分析，整合系统、算法和应用程序，以实现在普适计算和科学发现中的高效有效数据分析。'
            }, {
                'name': '顾宁',
                'photo': 'Ning_Gu.jpg',
                'url': 'https://cscw.fudan.edu.cn/ninggu/list.htm',
                'title': '复旦大学计算机科学技术学院教授、博士生导师，复旦大学社会计算研究中心主任，中国计算机学会会士，IET(英国工程技术学会)Fellow，CCF协同计算专委会荣誉主任。长期从事以人为中心的协同计算研究，包括分布式协同、社会化协同和群智协同的理论与技术。'
            }, {
                'name': '卢暾',
                'photo': 'Tun_Lu.jpg',
                'url': 'https://cscw.fudan.edu.cn/tunlu/list.htm',
                'title': '复旦大学计算机科学技术学院教授、博士生导师，复旦大学计算机科学技术学院副院长。研究领域涵盖CSCW与社会计算，人机协同与交互，群智协同，推荐系统，服务与云计算。'
            }, {
                'name': '李东胜',
                'photo': 'Dongsheng_Li.jpg',
                'url': 'http://recmind.cn/index.html',
                'title': '微软亚洲研究院（MSRA）上海分院的首席研究经理，复旦大学计算机科学学院的兼职教授，曾在IBM中国研究院上海分院担任研究员，ACM和IEEE的高级会员，并担任多个顶级会议的程序委员会成员，例如NIPS、ICML、ICLR等。研究兴趣包括机器学习、健康人工智能和推荐系统。'
            }, {
                'name': '董明智',
                'photo': 'Mingzhi_Dong.jpg',
                'url': 'https://cscw.fudan.edu.cn/mingzhidong/list.htm',
                'title': '英国巴斯大学计算机学院讲师，英国伦敦大学学院博士。研究领域涵盖理论或直观可解释的机器学习算法及其在计算机视觉、人机交互等领域的应用。'
            }, {
                'name': '赵莹莹',
                'photo': 'Yingying_Zhao.jpg',
                // 'url': 'https://eng.ox.ac.uk/people/yujiang-wang/',
                'title': '思克莱德大学计算机与信息科学系讲师，同济大学博士。研究领域涵盖智能人机交互、机器学习和深度学习系统及应用。近年来，她的研究聚焦于构建基于视觉智能的交互式系统，旨在探索用户的注意力、情感、意图、认知和行为，并为用户提供人机交互场景下的智能服务。'
            },{
                'name': '王宇江',
                'photo': 'Yujiang_Wang.jpg',
                'url': 'https://eng.ox.ac.uk/people/yujiang-wang/',
                'title': '牛津大学高等研究院（苏州）研究员，在伦敦帝国学院获得计算机视觉博士学位，并分别在清华大学、伦敦帝国学院和伦敦大学学院获得了学士学位和两个荣誉硕士学位。研究兴趣主要集中在医疗人工智能、唇语识别、智能可穿戴设备等领域。'
            }, {
                'name': '杨笑尘',
                'photo': 'Xiaochen_Yang.jpg',
                'url': 'https://www.gla.ac.uk/schools/mathematicsstatistics/staff/xiaochenyang/',
                'title': '英国格拉斯哥大学数学与统计学院讲师，伦敦大学学院统计科学博士。研究方向涵盖小样本机器学习、可信机器学习以及医学科学领域的机器学习方法。'
            }, {
                'name': '朱睿',
                'photo': 'Rui_Zhu.jpg',
                'url': 'https://www.bayes.city.ac.uk/faculties-and-research/experts/rui-zhu',
                'title': '伦敦大学城市学院贝叶斯商学院副教授，伦敦大学学院统计科学系博士。研究方向涵盖统计学习，基于子空间的分类方法，光谱数据分析，高光谱图像分析，图像质量评价等.'
            }],
            students: [{
                'name': '许震宇',
                'photo': 'Zhenyu_Xu.jpg',
            }, {
                'name': '张睿',
                'photo': 'Rui_Zhang.jpg',
            }, {
                'name': '徐海琳',
                'photo': 'Hailin_Xu.jpg',
            }, {
                'name': '潘文韬',
                'photo': 'Wentao_Pan.jpg',
            }, {
                'name': '方唱凯',
                'photo': 'Changkai_Fang.jpg',
            }, {
                'name': '董方',
                'photo': 'Fang_Dong.jpg',
            }, {
                'name': '陈安瑞',
                'photo': 'Anrui_Chen.jpg',
            }, {
                'name': '唐思源',
                'photo': 'Siyuan_Tang.jpg',
            }, {
                'name': '周继先',
                'photo': 'Jixian_Zhou.jpg',
            }, {
                'name': '曹恒杰',
                'photo': 'Hengjie_Cao.jpg',
            }, {
                'name': '陈朦伊',
                'photo': 'Mengyi_Chen.jpg',
            }, {
                'name': '高铭凯',
                'photo': 'Mingkai_Gao.jpg',
            }, {
                'name': '陆天麟',
                'photo': 'Tianlin_Lu.jpg',
            }, {
                'name': '杨倚风',
                'photo': 'Yifeng_Yang.jpg',
            }, {
                'name': '黄和金',
                'photo': 'Hejin_Huang.jpg',
            }, {
                'name': '程嘉伟',
                'photo': 'Jiawei_Cheng.jpg',
            },{
                'name': '李京桥',
                'photo': 'Jingqiao_Li.jpg',
            },{
                'name': '张俊逸',
                'photo': 'Junyi_Zhang.jpg',
            },{
                'name': '黄睿钧',
                'photo': 'Ruijun_Huang.jpg',
            },{
                'name':'陈子源',
                'photo':'Ziyuan_Chen.jpg',
            },{
                'name':'任宇琪',
                'photo':'Yuqi_Ren.jpg',
            },{
                'name':'李祯宁',
                'photo':'Zhenning_Li.jpg',
            },{
                'name':'漆力同',
                'photo':'Litong_Qi.jpg',
            },{
                'name':'赵伊扬',
                'photo':'Yiyang_Zhao.jpg',
            },{
                'name':'杨嘉鑫',
                'photo':'Jiaxin_Yang.jpg',
            },{
                'name':'方宇轩',
                'photo':'Yuxuan_Fang.jpg',
            },{
                'name':'李尔特',
                'photo':'Erte_Li.jpg',
            },{
                'name':'罗意明',
                'photo':'Yiming_Luo.jpg',
            },{
                'name':'张鑫',
                'photo':'Xin_Zhang.jpg',
            },{
                'name':'甘陈宇',
                'photo':'Chenyu_Gan.jpg',
            },{
                'name':'钱乐萱',
                'photo':'Lexuan_Qian_new.jpg',
            },{
                'name':'刘诗颖',
                'photo':'Shiying_Liu.jpg',
            },{
                'name':'毛佳伟',
                'photo':'Jiawei_Mao.jpg',
            },{
                'name':'黄振东',
                'photo':'Zhendong_Huang.jpg'
            }],
            alumnus: [{
                'name': '卢玉田',
                'photo': 'Yutian_Lu.jpg',
            }, {
                'name': '李宁',
                'photo': 'Ning_Li.jpg',
            }, {
                'name': '陆舟洋',
                'photo': 'Zhouyang_Lu.jpg',
            }, {
                'name': '陈一萱',
                'photo': 'Yixuan_Chen.jpg',
            }, {
                'name': '刘怡婷',
                'photo': 'Yiting_Liu.jpg',
                'title': '博士后，复旦大学计算机应用技术博士，研究领域为电子设计自动化（EDA）、VLSI物理设计、大语言模型、嵌入式系统开发。'
            }, {
                'name': '王显伟',
                'photo': 'Xianwei_Wang.jpg',
            },  {
                'name': '赵国杰',
                'photo': 'Guojie_Zhao.jpg',
            }, {
                'name': '王辰雨',
                'photo': 'Chenyu_Wang.jpg',
            }],
            unused: [{
                'name': '丁向华',
                'photo': 'Xianghua_Ding.jpg',
                'url': 'https://xianghuading.com/',
                'title': 'Fudan University'
            }, {
                'name': '赵一峰',
                'photo': 'del_Yifeng_Zhao.jpg',
            }, {
                'name': '陈子豪',
                'photo': 'del_Zihao_Chen.jpg',
            }, {
                'name': '吴宇婷',
                'photo': 'del_Yuting_Wu.jpg',
            }, {
                'name': '齐祥遥',
                'photo': 'del_Xiangyao_Qi.jpg',
            }, {
                'name': '卢琦',
                'photo': 'del_Qi_Lu.jpg',
            }
            ]
        };
    },
    methods: {
        open(url) {
            if (url) {
                window.open(url)
            }
        },
    },
};
</script>
<style></style>
